module.exports = __webpack_public_path__ + "static/media/refundPic.564550cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/refundPic.jpg
// module id = 2016
// module chunks = 6